import global from './global.json'

export default {
  global,
}
